import { markPriorityInboxThreadReadInCache } from "@circle-react/lib/queries/priorityInboxThreads";

import { reactQueryPost } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export const markChatThreadsAsRead = (chatThreadId: number) =>
  reactQueryPost(
    internalApi.chatThreads.markAsRead({
      id: chatThreadId,
    }),
  ).then(() => {
    markPriorityInboxThreadReadInCache({ chatThreadId });
  });
